import { useContext } from "react";
import { ViewContext } from "../providers";

/**
 * Hook that returns the view context value
 * 
 * @returns The view context
 */
const useView = () => {
  const viewContext = useContext(ViewContext);

  if (!viewContext) {
    throw new Error("useView must be used within an ViewProvider");
  }
  return viewContext;
};

export default useView;
